import { toast } from "react-toastify";
import Loader from "src/components/common/Loader/Loader";
import { usePutBusScheduleSimulateQuery } from "src/services/react-query-apis/put-bus-schedule-simulate";
import { usePutBusScheduleMutation } from "src/services/react-query-apis/put-bus-schedule";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataChanges from "src/components/common/update-confirmation/data-changes";
import moment from "moment";
import { getCurrentMonth } from "src/services/auth/token";
import BusScheduleAffectedAttendances from "./bus-schedule-affected-attendances";

const ScheduleUpdateConfirm = ({ updatePayload, onClose, onBack }) => {
  const putScheduleSimulateQuery = usePutBusScheduleSimulateQuery({
    ...updatePayload,
    queryConfig: {
      staleTime: 0,
      enabled: !!updatePayload,
    },
  });

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      onClose();
    },
  };

  const putScheduleMutation = usePutBusScheduleMutation({
    mutationConfig,
  });

  if (putScheduleSimulateQuery.isFetching) {
    return <Loader message="データを取得中..." />;
  }

  if (putScheduleSimulateQuery.isError) {
    return (
      <>
        <div className="text-danger text-center mb-3 p-1 rounded bg-light border fw-bold">
          {putScheduleSimulateQuery.error.response?.data?.message ||
            "エラーが発生しました"}
        </div>
        <div className="text-end">
          <button className="btn btn-primary" onClick={onBack}>
            戻る
          </button>
        </div>
      </>
    );
  }

  const { affected_attendances, changes, can_update } =
    putScheduleSimulateQuery.data?.data;

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column w-100">
        <div>
          <div
            className="alert alert-warning mb-3 text-center p-1"
            role="alert"
          >
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            この変更は{" "}
            {moment(getCurrentMonth())
              .add(1, "month")
              .format("YYYY年MM月")}{" "}
            から適用されます
          </div>
          <div className="mb-4">
            <h6 className="text-center mb-3">スケジュール変更の確認</h6>
            <div className="d-flex flex-column gap-3">
              <DataChanges changes={changes} />
            </div>
          </div>

          {affected_attendances.length > 0 && (
            <div className="mb-3">
              <h6 className="text-center mb-3">影響を受ける出席予定</h6>
              <BusScheduleAffectedAttendances
                affectedAttendances={affected_attendances}
              />
            </div>
          )}

          {!can_update && (
            <div className="alert alert-warning text-center mb-3" role="alert">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
              エラーを修正してから再度お試しください
            </div>
          )}
          <div className="d-flex gap-2 justify-content-end mt-3">
            <button className="btn btn-secondary px-4" onClick={onBack}>
              戻る
            </button>
            <button
              className="btn btn-primary px-4"
              onClick={() => {
                putScheduleMutation.mutate(updatePayload);
              }}
              disabled={putScheduleMutation.isPending || !can_update}
            >
              {putScheduleMutation.isPending ? "処理中..." : "更新"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleUpdateConfirm;
